<template>
  <VCard class="tw-w-full" padding="5">
    <section class="serviceMainWrapper">
      <VText class="tw-mb-6 tw-block" cfg="sans/20/bold" html-tag="h2">
        {{ $t('influencer.profile.slug.recentOpportunities.title') }}
      </VText>
      <div class="tw-grid tw-grid-cols-1 tw-gap-6 md:tw-grid-cols-2">
        <VRecentOpportunitiesCard
          v-for="recentOpportunity in recentOpportunities"
          :key="recentOpportunity.track_link"
          :influencer="influencer"
          :recent-opportunity="recentOpportunity"
        />
      </div>
    </section>
  </VCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import VCard from '~/components/ui/VCard.vue'
import VRecentOpportunitiesCard from '~/components/ui/VRecentOpportunitiesCard.vue'
import VText from '~/components/ui/VText.vue'

import type {
  Influencer,
  InfluencerRecentOpportunities,
} from '~/types/influencer'
import type { PropType } from 'vue'

export default defineComponent({
  components: {
    VText,
    VCard,
    VRecentOpportunitiesCard,
  },
  props: {
    recentOpportunities: {
      type: Array as PropType<InfluencerRecentOpportunities[]>,
      required: true,
    },
    influencer: {
      type: Object as PropType<Influencer>,
      required: true,
    },
  },
})
</script>
